
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 100"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#ED2939","d":"M0 0h150v100H0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M0 0h40v40H0z"}}),_c('path',{attrs:{"fill":"#002395","d":"M0 0h20v40H0z"}}),_c('path',{attrs:{"fill":"none","stroke":"#FFF","d":"M0 40h60V0"}}),_c('path',{attrs:{"fill":"#FFF","d":"M105 46L93 34h24zm-4 4L89 38v24zm4 4L93 66h24zm4-4l12-12v24z"}})])
          )
        }
      }
    